<template>
  <div class="kinderhort">
    <v-tabs dark background-color="transparent" color="primary" class="darkbackground" centered v-model="tab">
      <v-tabs-slider color="white" class="darkbackground"></v-tabs-slider>
      <v-tab class="darkbackground" v-for="item in items" :key="item">
        {{ item }}
      </v-tab>
    </v-tabs>

    <v-tabs-items class="darkbackground" v-model="tab">
      <v-tab-item class="mb-15 mt-5 darkbackground">
        <kinderhort-statistik></kinderhort-statistik>
      </v-tab-item>

      <v-tab-item class="darkbackground">
        <v-card flat color="transparent">
          <v-row justify="center">
            <v-col cols="12" md="10" lg="8">
              <v-card-title class="d-flex justify-center text-center mb-4 mt-5 text-h5 text-sm-h4 font-weight-bold white--text">
                Öffnungszeiten bearbeiten
              </v-card-title>

              <v-card dark class="mx-auto pa-4 pa-md-8 rounded-lg" color="#1E1E1E">
                <v-switch
                  v-model="active"
                  inset
                  :label="active ? 'Öffnungszeiten sind aktiv' : 'Öffnungszeiten sind deaktiviert'"
                  color="primary"
                  class="mb-4"></v-switch>
                <v-text-field
                  v-model="notes"
                  label="Notiz (z.B. für Ferien)"
                  placeholder="Wir haben vom 24.12 bis 02.01 geschlossen."
                  outlined
                  class="mb-8"></v-text-field>

                <fieldset :disabled="!active">
                  <v-list two-line color="transparent" class="pa-0">
                    <v-list-item
                      v-if="days"
                      v-for="(daySlots, dayKey) in days"
                      :key="dayKey"
                      class="day-list-item d-flex flex-column flex-sm-row align-center">
                      <v-list-item-content class="mb-4 mb-sm-0 text-center text-sm-left">
                        <v-list-item-title class="font-weight-bold text-subtitle-1">
                          {{ germanDayNames[dayKey] }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="subtitle-line-height" :class="{ 'grey--text text--lighten-1': !daySlots[0].isOpen }">
                          {{
                            daySlots[0].isOpen && daySlots[0].open && daySlots[0].close
                              ? `${formatToDisplayTime(daySlots[0].open)} - ${formatToDisplayTime(daySlots[0].close)}`
                              : "Geschlossen"
                          }}
                        </v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-action>
                        <div class="d-flex align-center justify-space-around justify-sm-end action-controls">
                          <v-menu offset-y :close-on-content-click="false" v-model="menus[dayKey + '_open']">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-bind="attrs"
                                v-on="on"
                                placeholder="Von"
                                readonly
                                :value="formatToDisplayTime(daySlots[0].open)"
                                :disabled="!daySlots[0].isOpen"
                                dense
                                solo
                                hide-details
                                style="max-width: 120px"
                                append-icon="mdi-clock-outline"
                                class="clickable-time-field"></v-text-field>
                            </template>
                            <v-time-picker
                              v-if="menus[dayKey + '_open']"
                              :value="formatToDisplayTime(daySlots[0].open)"
                              format="24hr"
                              @input="updateTime(dayKey, 'open', $event)"
                              @click:minute="menus[dayKey + '_open'] = false"></v-time-picker>
                          </v-menu>

                          <v-menu offset-y :close-on-content-click="false" v-model="menus[dayKey + '_close']">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-bind="attrs"
                                v-on="on"
                                placeholder="Bis"
                                readonly
                                :value="formatToDisplayTime(daySlots[0].close)"
                                :disabled="!daySlots[0].isOpen"
                                dense
                                solo
                                hide-details
                                style="max-width: 120px"
                                append-icon="mdi-clock-outline"
                                class="clickable-time-field"></v-text-field>
                            </template>
                            <v-time-picker
                              v-if="menus[dayKey + '_close']"
                              :value="formatToDisplayTime(daySlots[0].close)"
                              format="24hr"
                              @input="updateTime(dayKey, 'close', $event)"
                              @click:minute="menus[dayKey + '_close'] = false"></v-time-picker>
                          </v-menu>

                          <v-switch v-model="daySlots[0].isOpen" color="primary" dense hide-details></v-switch>
                        </div>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </fieldset>
              </v-card>

              <v-row class="justify-center mt-10 mb-4">
                <v-col cols="auto">
                  <v-btn @click="saveDays()" color="primary" class="white--text rounded-lg save-btn" x-large>
                    <v-icon left>mdi-content-save</v-icon>
                    Änderungen speichern
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
// Der Script-Teil bleibt unverändert, da die Logik stabil ist.
import api from "../../../api"
import KinderhortStatistik from "./studioDashboardDaycareStatistic.vue"

export default {
  name: "StudioDashboardDaycare",
  components: { KinderhortStatistik },
  data() {
    return {
      tab: null,
      items: ["Anmeldungen", "Öffnungszeiten"],
      days: null,
      active: false,
      notes: "",
      menus: {},
      germanDayNames: {
        monday: "Montag",
        tuesday: "Dienstag",
        wednesday: "Mittwoch",
        thursday: "Donnerstag",
        friday: "Freitag",
        saturday: "Samstag",
        sunday: "Sonntag",
      },
    }
  },
  created() {
    this.fetchKinderhortHours()
  },
  methods: {
    updateTime(dayKey, type, time) {
      if (this.days && this.days[dayKey] && this.days[dayKey][0]) {
        this.$set(this.days[dayKey][0], type, this.formatToApiTime(time))
      }
    },
    formatToDisplayTime(timeString) {
      if (!timeString || String(timeString).length !== 4) return ""
      return `${String(timeString).substring(0, 2)}:${String(timeString).substring(2, 4)}`
    },
    formatToApiTime(timeString) {
      if (!timeString) return ""
      return timeString.replace(":", "")
    },
    async fetchKinderhortHours() {
      this.$emit("loading")
      try {
        const daysData = await api.fetchBusinessHours("kinderhort")
        if (daysData && daysData.days) {
          this.active = daysData.active
          this.days = daysData.days
          this.notes = daysData.notes || ""
        } else {
          this.initDays()
        }
      } catch (e) {
        console.error("Fehler beim Abrufen der Öffnungszeiten:", e)
        this.initDays()
        this.$toast.error("Öffnungszeiten konnten nicht geladen werden.")
      } finally {
        this.$emit("finishedloading")
      }
    },
    initDays() {
      this.days = {
        monday: [{ open: "", close: "", id: "1", isOpen: false }],
        tuesday: [{ open: "", close: "", id: "2", isOpen: false }],
        wednesday: [{ open: "", close: "", id: "3", isOpen: false }],
        thursday: [{ open: "", close: "", id: "4", isOpen: false }],
        friday: [{ open: "", close: "", id: "5", isOpen: false }],
        saturday: [{ open: "", close: "", id: "6", isOpen: false }],
        sunday: [{ open: "", close: "", id: "0", isOpen: false }],
      }
    },
    async saveDays() {
      const businessHours = {
        type: "kinderhort",
        days: this.days,
        active: this.active,
        notes: this.notes,
      }
      try {
        const status = await api.updateBusinessHours(businessHours)
        if (status) {
          this.$toast.success("Erfolgreich gespeichert")
        } else {
          this.$toast.error("Fehler beim Speichern.")
        }
      } catch (e) {
        console.error("Fehler beim Speichern der Öffnungszeiten:", e)
        this.$toast.error("Ein unerwarteter Fehler ist aufgetreten.")
      }
    },
  },
}
</script>

<style lang="scss" scoped>
fieldset {
  border: none;
  padding: 0;
  margin: 0;
}

.day-list-item {
  background-color: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 12px !important;
  transition: all 0.3s ease-out;

  &:hover {
    transform: translateY(-3px);
    border-color: var(--v-primary-base);
    box-shadow: 0 4px 25px -5px var(--v-primary-base);
  }
}

.subtitle-line-height {
  line-height: 1.2rem;
}

.clickable-time-field {
  cursor: pointer;
  transition: box-shadow 0.2s ease;
  &:hover {
    box-shadow: 0 0 10px -2px rgba(255, 255, 255, 0.2);
  }
}

.save-btn {
  background: linear-gradient(45deg, var(--v-primary-base), var(--v-primary-darken1)) !important;
  box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.4) !important;
  transition: all 0.2s ease-in-out;
  &:hover {
    transform: scale(1.03);
    box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.4) !important;
  }
}

.action-controls {
  gap: 12px;
}
</style>
